

















import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { isWeiXin } from '@/common/ts/common';
import { getNews } from '../api';
Vue.use(List);

@Component({
  components: {
    NewsItem,
    BottomTabbar,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  active = 1;
  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  onLoad() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/d/file/image/default/2023-09-25/5beadd06122151bed62fde38c29fbf6a.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2023大渡口十大江湖菜评选活动',
      url: location.href,
      subtitle: `2023大渡口十大江湖菜评选活动`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2023大渡口十大江湖菜评选活动',
        subtitle: `2023大渡口十大江湖菜评选活动`,
        image: cover,
      });
    }
    getNews(this.page, '全部', '9733').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode === 404) {
      this.finished = true;
    } else {
      if (!res.data.data || res.data.data.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.data[0].list];
        }
      }
    }
    this.loading = false;
  }
}
